program TMSWeb_ResponsiveManager;

uses
  Vcl.Forms,
  WEBLib.Forms,
  Uresponsivemanager in 'Uresponsivemanager.pas'{*.html};

begin
  Application.Initialize;
  Application.MainFormOnTaskbar := True;
  Application.CreateForm(TForm1, Form1);
  Application.Run;
end.
